export default __webpack_public_path__ + "static/media/discounts-family-image.5d14d3ba.svg";